module.exports = __webpack_public_path__ + "img/FEMEA_13-24.70e54bef.jpeg";